import App from './App.svelte';
import { themeStore } from './stores/themeStore.js';
import { clerkService } from './services/clerkService.js';
import { clerkStore } from './stores/clerkStore.js';
import { backendService } from './services/backendService.js';

// Make services globally available for debugging
window.clerkService = clerkService;
window.backendService = backendService;

// Initialize theme before app starts
themeStore.init();

/**
 * Initialize application with authentication
 */
async function initializeApp() {
	try {
		// Initialize Clerk authentication
		const clerk = await clerkService.initialize();
		clerkStore.init(clerk);
		
		// Check if user is authenticated
		if (!clerk.user) {
			console.log('User not authenticated, showing sign-in');
			
			// Show sign-in modal
			await clerk.openSignIn({
				afterSignInUrl: window.location.href,
				afterSignUpUrl: window.location.href,
				appearance: {
					layout: {
						logoImageUrl: '/fearn_logo.svg'
					},
					elements: {
						formFieldInput: {
							fontSize: '16px'
						},
						identifierPreview: {
							fontSize: '16px'
						},
						formFieldLabel: {
							fontSize: '14px'
						},
						formButtonPrimary: {
							fontSize: '16px'
						}
					}
				}
			});
			
			// Wait for authentication
			return new Promise((resolve) => {
				clerk.addListener(() => {
					if (clerk.user) {
						console.log('User authenticated:', clerk.user.primaryEmailAddress?.emailAddress);
						// Reload the page to initialize app with authenticated user
						window.location.reload();
					}
				});
			});
		}
		
		console.log('User authenticated:', clerk.user.primaryEmailAddress?.emailAddress);
		
	} catch (error) {
		console.error('Clerk initialization failed:', error);
		// Continue without auth in development
		const isDevelopment = import.meta.env?.MODE === 'development' ||
			window.location.hostname === 'localhost' ||
			window.location.hostname === '127.0.0.1';

		if (isDevelopment) {
			console.warn('Running without authentication in development mode');
		} else {
			alert('Authentication service unavailable. Please check your internet connection and try again.');
			return;
		}
	}
	
	// Mount the main app
	const app = new App({
		target: document.getElementById('app')
	});
	
	return app;
}

// Start the application
const app = initializeApp();

export default app;
